// see UrlParamToWatch interface for list of attributes supported
export const ROOT_PARAMS = [
  { name: 'frozen_fuzzy_filter', mandatory: false },
  { name: 'fuzzy_filter', mandatory: true, defaultValue: { expression: [] } },
  { name: 'activetest_clicked', mandatory: false },
  { name: 'test_list_filter', mandatory: false }
];
